"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_VIEW_PERMISSIONS = void 0;
var GET_VIEW_PERMISSIONS = exports.GET_VIEW_PERMISSIONS = 'GET_VIEW_PERMISSIONS';